import React, { useEffect, useRef } from 'react';
import { FiX } from 'react-icons/fi';

const ImageLightbox = ({ image, onClose }) => {
	const overlayRef = useRef(null);

	useEffect(() => {
		const handleKeyDown = (e) => {
			if (e.key === 'Escape') onClose();
		};
		document.addEventListener('keydown', handleKeyDown);
		return () => document.removeEventListener('keydown', handleKeyDown);
	}, [onClose]);

	useEffect(() => {
		if (overlayRef.current) overlayRef.current.focus();
	}, []);

	if (!image) return null;

	return (
		<div
			ref={overlayRef}
			className='fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm'
			onClick={onClose}
			role='dialog'
			aria-label='Image preview'
			tabIndex={-1}
		>
			<button
				onClick={onClose}
				className='absolute top-4 right-4 p-2 rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors duration-200'
				aria-label='Close image preview'
			>
				<FiX className='w-5 h-5' />
			</button>
			<img
				src={image.src}
				alt={image.alt}
				className='max-w-[90vw] max-h-[85vh] object-contain rounded-lg shadow-2xl'
				onClick={(e) => e.stopPropagation()}
			/>
		</div>
	);
};

export default ImageLightbox;
